var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wh100" }, [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _vm.goodsShipVoucher.ioFlag == 1
              ? _c("el-breadcrumb-item", [_vm._v("发货单")])
              : _vm._e(),
            _vm._v(" "),
            _vm.goodsShipVoucher.ioFlag == -1 &&
            _vm.goodsShipVoucher.deliverType == 0
              ? _c("el-breadcrumb-item", [_vm._v("换货收货单")])
              : _vm._e(),
            _vm._v(" "),
            _vm.goodsShipVoucher.ioFlag == -1 &&
            _vm.goodsShipVoucher.deliverType == -1
              ? _c("el-breadcrumb-item", [_vm._v("退货收货单")])
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "block-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "block-container" }, [
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("table", { staticClass: "custom-tbl" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("tbody", { staticClass: "body" }, [
              _c("tr", { staticClass: "row align-left" }, [
                _c(
                  "td",
                  {
                    staticClass: "align-left ellipsis",
                    attrs: { title: _vm.goodsShipVoucher.sellerName }
                  },
                  [_vm._v(_vm._s(_vm.goodsShipVoucher.sellerName))]
                ),
                _vm._v(" "),
                _c("td", { staticStyle: { width: "200px" } }, [
                  _vm._v(_vm._s(_vm.goodsShipVoucher.senderContactName))
                ]),
                _vm._v(" "),
                _c("td", { staticStyle: { width: "200px" } }, [
                  _vm._v(_vm._s(_vm.goodsShipVoucher.senderContactTel))
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "block-container" }, [
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("table", { staticClass: "custom-tbl" }, [
            _c("thead", { staticClass: "head" }, [
              _c("tr", { staticClass: "row align-left" }, [
                _c(
                  "th",
                  { staticStyle: { width: "200px", "text-align": "left" } },
                  [_vm._v("业务单元")]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  { staticStyle: { width: "200px", "text-align": "left" } },
                  [_vm._v("所属部门")]
                ),
                _vm._v(" "),
                _vm.goodsShipVoucher.ioFlag == 1
                  ? _c("th", [_vm._v("收货地址")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.goodsShipVoucher.ioFlag == -1
                  ? _c("th", [_vm._v("发货地址")])
                  : _vm._e(),
                _vm._v(" "),
                _c("th", { staticStyle: { width: "200px" } }, [
                  _vm._v("联系人")
                ]),
                _vm._v(" "),
                _c("th", { staticStyle: { width: "200px" } }, [
                  _vm._v("联系方式")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tbody", { staticClass: "body" }, [
              _c("tr", { staticClass: "row align-left" }, [
                _c(
                  "td",
                  {
                    staticClass: "ellipsis",
                    staticStyle: { width: "200px", "text-align": "left" },
                    attrs: { title: _vm.goodsShipVoucher.buyerShopName }
                  },
                  [_vm._v(_vm._s(_vm.goodsShipVoucher.buyerShopName))]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "ellipsis",
                    staticStyle: { width: "200px", "text-align": "left" },
                    attrs: { title: _vm.goodsShipVoucher.buyerBizUnitName }
                  },
                  [_vm._v(_vm._s(_vm.goodsShipVoucher.buyerBizUnitName))]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "ellipsis",
                    attrs: { title: _vm.goodsShipVoucher.buyerRecvAddr }
                  },
                  [_vm._v(_vm._s(_vm.goodsShipVoucher.buyerRecvAddr))]
                ),
                _vm._v(" "),
                _c("td", { staticStyle: { width: "200px" } }, [
                  _vm._v(_vm._s(_vm.goodsShipVoucher.buyerRecvContractName))
                ]),
                _vm._v(" "),
                _c("td", { staticStyle: { width: "200px" } }, [
                  _vm._v(_vm._s(_vm.goodsShipVoucher.buyerRecvContactTel))
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block-container" },
        [
          _c(
            "el-form",
            { ref: "goods", attrs: { model: _vm.goodsShipVoucher } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.goodsShipVoucher.itemList, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "left", prop: "title", label: "商品名称" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "200",
                      prop: "brandName",
                      label: "品牌名称"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "120",
                      prop: "asmblFlag",
                      label: "提供商品标识码"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.vendorUknoFlag
                              ? _c("span", [_vm._v("是")])
                              : _c("span", [_vm._v("否")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "100",
                      prop: "price",
                      label: "含税价(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.price != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.price.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "100",
                      prop: "taxRate",
                      label: "税率(%)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.taxRate != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.taxRate.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "100",
                      prop: "ntxPrice",
                      label: "未税价(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.ntxPrice != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.ntxPrice.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "120",
                      prop: "amount",
                      label: "费用小计(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.amount != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.amount.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "120",
                      prop: "ntxAmount",
                      label: "未税小计(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.ntxAmount != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.ntxAmount.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.goodsShipVoucher.ioFlag == 1
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "120",
                          prop: "quantity",
                          label: "发货数量"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.goodsShipVoucher.ioFlag == -1
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "120",
                          prop: "quantity",
                          label: "收货数量"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.warehouseId != null
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "120",
                          prop: "stockQuantity",
                          label: "库存数量"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.stockQuantity == null
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: { color: "red" },
                                        attrs: { title: "仓库中没有此商品" }
                                      },
                                      [_vm._v("无")]
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(rows.row.stockQuantity))
                                    ])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "left", prop: "desc", label: "说明" }
                  }),
                  _vm._v(" "),
                  _vm.goodsShipVoucher.ioFlag == 1 &&
                  _vm.goodsShipVoucher.receiveState == 0 &&
                  _vm.goodsShipVoucher.invalid == 0
                    ? _c("el-table-column", {
                        attrs: { width: "100", label: "操作" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c(
                                  "i",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.shipVoucherOffset(rows.row)
                                      }
                                    }
                                  },
                                  [_vm._v("冲红")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.goodsShipVoucher.shipProxied
        ? _c("div", [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _vm._m(5),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x bottom-line",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.goodsShipVoucher.shipperName,
                      callback: function($$v) {
                        _vm.$set(_vm.goodsShipVoucher, "shipperName", $$v)
                      },
                      expression: "goodsShipVoucher.shipperName"
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _c("div", { staticClass: "form-single mt20 mb20" }, [
        _c("div", { staticClass: "title" }, [_vm._v("预计到货日期")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.goodsShipVoucher.expectArriveDate || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single mt20 mb20" }, [
        _c("div", { staticClass: "title" }, [_vm._v("公司名称")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "pos-rel", staticStyle: { width: "225px" } },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: true },
                model: {
                  value: _vm.goodsShipVoucher.logisComName,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsShipVoucher, "logisComName", $$v)
                  },
                  expression: "goodsShipVoucher.logisComName"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.goodsShipVoucher.ioFlag == 1
        ? _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("公司代码")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x bottom-line",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.goodsShipVoucher.logisComCode,
                      callback: function($$v) {
                        _vm.$set(_vm.goodsShipVoucher, "logisComCode", $$v)
                      },
                      expression: "goodsShipVoucher.logisComCode"
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-single mt20 mb20" }, [
        _c("div", { staticClass: "title" }, [_vm._v("物流单号")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "pos-rel", staticStyle: { width: "225px" } },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: true },
                model: {
                  value: _vm.goodsShipVoucher.logisExpNo,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsShipVoucher, "logisExpNo", $$v)
                  },
                  expression: "goodsShipVoucher.logisExpNo"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single mt20 mb20" }, [
        _c("div", { staticClass: "title" }, [_vm._v("物流费用(元)")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "pos-rel", staticStyle: { width: "225px" } },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: true },
                model: {
                  value: _vm.goodsShipVoucher.logisFee,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsShipVoucher, "logisFee", $$v)
                  },
                  expression: "goodsShipVoucher.logisFee"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.goodsShipVoucher.exceptional
        ? _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("异常描述")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.goodsShipVoucher.exceptional
        ? _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", {}, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "225px" } },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.goodsShipVoucher.exceptionDesc))
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type == "confirmedShip"
        ? _c("div", [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c(
                "div",
                {
                  staticClass: "title required",
                  staticStyle: { width: "90px" }
                },
                [_vm._v("出库仓库")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content",
                  staticStyle: { "padding-left": "100px" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.compareIn },
                      model: {
                        value: _vm.warehouseId,
                        callback: function($$v) {
                          _vm.warehouseId = $$v
                        },
                        expression: "warehouseId"
                      }
                    },
                    _vm._l(_vm.warehouseList, function(item) {
                      return _c("el-option", {
                        key: item.name,
                        attrs: { label: item.name, value: item.id }
                      })
                    })
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("卖家信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row align-left" }, [
        _c("th", { staticClass: "align-left" }, [_vm._v("卖家名称")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [_vm._v("发货人")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [
          _vm._v("发货人联系方式")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("机构信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("商品信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("委托发货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("委托发货方")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("物流信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("出库仓库")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a47cfc0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a47cfc0c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsShipVoucherInfo.vue
// module id = 1831
// module chunks = 1